import React from "react";

interface TabProps {
  setTab: (index: number) => void;
  tab: number;
}

const SettingsTabs: React.FC<TabProps> = ({ setTab, tab }) => {
  const tabs = [
    { label: "Admin Table", index: 0 },
    { label: "Create Admin", index: 1 },
    { label: "Remove Admin", index: 2 },
    // { label: "Create Suspension", index: 3 },
    { label: "Suspension History", index: 3 },
    { label: "Meal Category", index: 4 },
    { label: "Create Meal Categories", index: 5 },
  ];

  return (
    <div className="w-full overflow-x-auto">
      <div className="flex gap-4 sm:gap-6 border-b-2 border-gray-300 min-w-max">
        {tabs.map(({ label, index }) => (
          <div
            key={index}
            onClick={() => setTab(index)}
            className={`whitespace-nowrap py-2 px-4 cursor-pointer text-sm sm:text-base ${
              tab === index
                ? "border-b-2 border-pr-primary text-pr-primary font-semibold"
                : "text-gray-600 hover:text-black"
            }`}
          >
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SettingsTabs;
